module.exports = __webpack_public_path__ + "img/logo_texto_preto.c94e1832.png";